module.exports = __webpack_public_path__ + "static/media/screen7.84d81ff7.png";